const FLASHLIGHT_DATA = {
  "qty-0": { id: 40237998997637, price: "00.00", price_cents: 0 },
  "qty-1": { id: 40478926995589, price: "19.00", price_cents: 1900 },
  "qty-2": { id: 40566138536069, price: "29.00", price_cents: 2900 },
};

// identifies the added product to cart
let flashlight_id = "";
let is_adding_flashlight = false;
const processed_line_item_ids = new Set();

document.addEventListener("DOMContentLoaded", function () {
  const flashlight_container = document.querySelector(
    "[data-js-flashlight-fieldset]",
  );
  const flashlight_msg = document.querySelector(
    "[data-js-no-lightup-feature-msg]",
  );
  const availability_map_dom = document.querySelector(
    "#flashlight-availability-map",
  );
  const variant_prices_dom = document.querySelector(
    "#flashlight-variant-prices",
  );
  const variant_id_input = document.querySelector(".product-variant-id");

  const flashlight_wrapper = document.querySelector(
    "[data-js-flashlight-wrapper]",
  );
  const flashlight_help_trigger = document.querySelector(
    "[data-js-flashlight-help-trigger]",
  );
  const flashlight_help_dialog = document.querySelector(
    "#flashlight-info-dialog",
  );

  if (!flashlight_container) {
    return console.log("Cant find flashlight container DOM element");
  }

  if (
    flashlight_help_trigger &&
    flashlight_help_dialog &&
    typeof flashlight_help_dialog.showModal === "function"
  ) {
    flashlight_help_trigger.addEventListener("click", function () {
      if (!flashlight_help_dialog.open) {
        flashlight_help_dialog.showModal();
      }
    });

    flashlight_help_dialog.addEventListener("click", function (event) {
      const dialog_rect = flashlight_help_dialog.getBoundingClientRect();
      const clicked_on_backdrop =
        event.clientX < dialog_rect.left ||
        event.clientX > dialog_rect.right ||
        event.clientY < dialog_rect.top ||
        event.clientY > dialog_rect.bottom;

      if (clicked_on_backdrop) {
        flashlight_help_dialog.close();
      }
    });
  }

  // first render
  const flashlight_lineitem_id = document.querySelector(
    '[data-js="flashlight-id"]',
  );
  if (!flashlight_lineitem_id) {
    return console.log("Cant find flashlight id line item DOM element");
  }
  flashlight_id = flashlight_lineitem_id.value;

  let flashlight_availability_map = {};
  let flashlight_variant_prices = {};

  if (availability_map_dom) {
    try {
      flashlight_availability_map = JSON.parse(
        availability_map_dom.textContent || "{}",
      );
    } catch (error) {
      console.log("Failed to parse flashlight availability map", error);
    }
  }

  if (variant_prices_dom) {
    try {
      flashlight_variant_prices = JSON.parse(
        variant_prices_dom.textContent || "{}",
      );
    } catch (error) {
      console.log("Failed to parse flashlight variant prices", error);
    }
  }

  function getSelectedFlashlightQty() {
    const selected = document.querySelector(
      '[data-js-flashlight-fieldset] input[name="flashlight"]:checked',
    );
    return selected?.value || "qty-0";
  }

  function getScopeRoot() {
    return flashlight_wrapper?.closest("product-info") || document;
  }

  function getFormattedMoney(cents) {
    if (window.FoxTheme?.Currency?.formatMoney) {
      return window.FoxTheme.Currency.formatMoney(
        cents,
        window.FoxTheme.settings.moneyFormat,
      );
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function updateDisplayedProductPrice() {
    if (!variant_id_input) {
      return;
    }

    const selected_variant_id = String(variant_id_input.value || "");
    const variant_price_data = flashlight_variant_prices[selected_variant_id];

    if (!variant_price_data) {
      return;
    }

    const selected_qty = getSelectedFlashlightQty();
    const flashlight_config =
      FLASHLIGHT_DATA[selected_qty] || FLASHLIGHT_DATA["qty-0"];
    const flashlight_price_cents = Number(flashlight_config.price_cents || 0);

    const base_price_cents = Number(variant_price_data.price || 0);
    const base_compare_cents = Number(variant_price_data.compare_at_price || 0);

    const final_price_cents = base_price_cents + flashlight_price_cents;
    const final_compare_cents = base_compare_cents + flashlight_price_cents;
    const is_on_sale = base_compare_cents > base_price_cents;

    const price_root = getScopeRoot().querySelector('[id^="price-"] .f-price');
    if (!price_root) {
      return;
    }

    const regular_price_el = price_root.querySelector(
      ".f-price__regular .f-price-item--regular",
    );
    const sale_price_el = price_root.querySelector(
      ".f-price__sale .f-price-item--sale",
    );
    const compare_price_el = price_root.querySelector(
      ".f-price__sale .f-price-item--regular",
    );

    if (is_on_sale) {
      price_root.classList.add("f-price--on-sale");

      if (regular_price_el) {
        regular_price_el.innerHTML = "";
      }

      if (sale_price_el) {
        sale_price_el.innerHTML = getFormattedMoney(final_price_cents);
      }

      if (compare_price_el) {
        compare_price_el.innerHTML = `<s>${getFormattedMoney(final_compare_cents)}</s>`;
      }
    } else {
      price_root.classList.remove("f-price--on-sale");

      if (regular_price_el) {
        regular_price_el.innerHTML = getFormattedMoney(final_price_cents);
      }

      if (sale_price_el) {
        sale_price_el.innerHTML = "";
      }

      if (compare_price_el) {
        compare_price_el.innerHTML = "";
      }
    }
  }

  function selectNoLightOption() {
    const no_light_radio = document.querySelector("#qty-0");
    const flashlight_lineitem = document.querySelector(
      '[data-js="flashlight"]',
    );
    const flashlight_price = document.querySelector(
      "[data-js-flashlight-price]",
    );

    if (no_light_radio) {
      no_light_radio.checked = true;
    }

    if (flashlight_lineitem) {
      flashlight_lineitem.value = "qty-0";
    }

    if (flashlight_price) {
      flashlight_price.innerText = FLASHLIGHT_DATA["qty-0"].price;
    }

    updateDisplayedProductPrice();
  }

  function syncFlashlightVisibility() {
    if (!variant_id_input) {
      return;
    }

    const selected_variant_id = String(variant_id_input.value || "");

    const hide_flashlight =
      String(flashlight_availability_map[selected_variant_id] || "") === "true";

    flashlight_container.hidden = hide_flashlight;

    if (flashlight_msg) {
      flashlight_msg.hidden = !hide_flashlight;
    }

    if (hide_flashlight) {
      selectNoLightOption();
    }

    updateDisplayedProductPrice();
  }

  syncFlashlightVisibility();

  // Variant selector updates the hidden variant id; keep flashlight UI in sync.
  document.addEventListener("change", function () {
    setTimeout(syncFlashlightVisibility, 0);
  });

  if (variant_id_input) {
    const variant_observer = new MutationObserver(syncFlashlightVisibility);
    variant_observer.observe(variant_id_input, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  flashlight_container.addEventListener("change", (e) => {
    const { value: quantity } = e.target;
    const flashlight_config = FLASHLIGHT_DATA[quantity];

    if (!flashlight_config) {
      return console.log("Invalid flashlight quantity option");
    }

    const flashlight_lineitem = document.querySelector(
      '[data-js="flashlight"]',
    );

    if (!flashlight_lineitem) {
      return console.log("Cant find flashlight line item DOM element");
    }
    flashlight_lineitem.value = quantity;

    const flashlight_price = document.querySelector(
      "[data-js-flashlight-price]",
    );
    if (flashlight_price) {
      flashlight_price.innerText = flashlight_config.price;
    }

    updateDisplayedProductPrice();
  });
});

// todo cuando no sean prod clear stix -> cheacar si tiene line item flashlight ya que el cart:update se va triggerar
// docs: https://docs.foxecom.com/hyper-theme/faqs/javascript-events-for-developers#id-4.-cart-updated
document.addEventListener("cart:updated", async function (evt) {
  if (is_adding_flashlight) {
    return;
  }

  const cart = evt?.detail?.cart;
  if (!cart || !Array.isArray(cart.items) || !flashlight_id) {
    return;
  }

  // Get the exact newly-added line item tracked by _Flashlight-ID.
  const added_item = cart.items.find((item) => {
    const item_link_id = item?.properties?.["_Flashlight-ID"];
    return (
      item_link_id != null && String(item_link_id) === String(flashlight_id)
    );
  });

  if (!added_item) {
    return;
  }

  const line_item_link_id = String(
    added_item?.properties?.["_Flashlight-ID"] || "",
  );
  if (line_item_link_id && processed_line_item_ids.has(line_item_link_id)) {
    return;
  }

  const added_qty = added_item?.properties?.["Flashlight"] || "qty-0";
  const flashlight_config = FLASHLIGHT_DATA[added_qty];

  if (!flashlight_config) {
    return console.log("Invalid flashlight quantity property in line item");
  }

  // qty-0 means customer selected no light up feature.
  if (added_qty === "qty-0") {
    processed_line_item_ids.add(line_item_link_id);
    rotateFlashlightLinkId();
    return;
  }

  const payload = {
    items: [
      {
        id: flashlight_config.id,
        quantity: 1,
      },
    ],
  };

  is_adding_flashlight = true;

  try {
    const updated = await updateCartData(payload);

    if (updated) {
      processed_line_item_ids.add(line_item_link_id);
      rotateFlashlightLinkId();

      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { open: true },
        }),
      );
    }
  } finally {
    is_adding_flashlight = false;
  }
});

async function updateCartData(payload) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Request failed: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("Failed to post cart data", error);
  }
}

function getRandomInt() {
  return String(Date.now()) + "-" + String(Math.floor(Math.random() * 100000));
}

function rotateFlashlightLinkId() {
  const randomNumber = getRandomInt();
  const flashlight_lineitem_id = document.querySelector(
    '[data-js="flashlight-id"]',
  );

  if (flashlight_lineitem_id) {
    flashlight_lineitem_id.value = randomNumber;
  }

  flashlight_id = randomNumber;
}
